import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import style from "./detailPost.module.css";
import { Icon } from "@iconify/react";
import Loading from "../../../UI/Loading";
const DetailPost = () => {
  const params = useParams();
  const idPost = params.idPost;
  /**
   * parser pada html-to-react perlu type string
   * jika type nya object maka akan error
   *
   * agar tidak error saat menggunakan html-to-react parser
   * jadi didefinisikan dulu post nya dengan string
   */
  const [detailPost, setDetailPost] = useState({
    post: "",
    user: { name: "" },
  });
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_LINK_API}post/${idPost}`)
      .then((res) => {
        setDetailPost(res.data.data);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [idPost]);

  if (loading == true) {
    return <Loading load={loading} />;
  }

  return (
    <div className={`detailPost ${style.detail_post} container-md`}>
      <div
        className={style.post_image}
        style={{
          backgroundImage: `url(${process.env.REACT_APP_LINK}foto/${detailPost.foto})`,
        }}
      ></div>
      <div className={style.post_description}>
        <div className={style.post_description__title}>
          <div className={style.post_description__title_text}>
            {detailPost.judul}
          </div>
          <div className={style.post_description__title_info}>
            <span>
              <Icon icon="healthicons:ui-user-profile-outline" />
              {detailPost.user.name}
            </span>
            <span>
              <Icon icon="healthicons:i-schedule-school-date-time" />
              {new Date(detailPost.updated_at).toLocaleDateString()}
            </span>
          </div>
        </div>
        <div className={style.post_description__text}>
          {parse(detailPost.post)}
        </div>
      </div>
    </div>
  );
};

export default DetailPost;
